<template>
  <div class="bg-white border rounded-lg shadow-sm" :class="{ 'ring-2 ring-blue-500': isSelected }">
    <!-- Заголовок -->
    <div
      class="flex items-center justify-between px-4 py-3 cursor-pointer rounded-t-lg"
      :class="isSelected ? 'bg-blue-50' : 'bg-gray-50'"
      @click="$emit('select', place._localId); $emit('focus-scanner')"
    >
      <div class="flex items-center gap-2">
        <span class="font-semibold text-lg">Место #{{ place.number }}</span>
        <span class="text-sm text-gray-500">({{ place.items?.length || 0 }} поз.)</span>
      </div>
      <button
        v-can-write
        @click.stop="$emit('delete', place._localId)"
        class="text-red-500 hover:text-red-700 p-1"
        title="Удалить место"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </button>
    </div>

    <!-- Габариты и вес -->
    <div class="px-4 py-2 border-t flex gap-3">
      <div class="flex-1">
        <label class="text-xs text-gray-500">Габариты (ДхШхВ, см, x - любая раскладка)</label>
        <input
          type="text"
          :value="place.dimensions"
          @input="$event.target.value = $event.target.value.replace(/[xXХ×]/g, 'х')"
          @change="updateField('dimensions', $event.target.value)"
          placeholder="00х00х00"
          class="w-full px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
      <div class="flex-1">
        <label class="text-xs text-gray-500">Вес брутто (кг)</label>
        <input
          type="number"
          step="0.01"
          :value="place.weight_gross"
          @change="updateField('weight_gross', parseFloat($event.target.value) || null)"
          placeholder="0.00"
          class="w-full px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
    </div>

    <!-- Позиции -->
    <div class="px-4 py-2 border-t">
      <div v-if="!place.items || place.items.length === 0" class="text-sm text-gray-400 py-2 text-center">
        Нет позиций
      </div>
      <div v-else class="divide-y">
        <div
          v-for="item in place.items"
          :key="item._localId"
          class="flex items-center justify-between py-1.5"
        >
          <div class="flex-1 min-w-0">
            <div class="text-sm truncate">{{ getProductName(item) }}</div>
            <div class="text-xs text-gray-500">
              {{ item.product?.sku || '' }}
              <span v-if="item.quantity > 1" class="ml-1">× {{ item.quantity }}</span>
            </div>
            <div v-if="getSerialNumber(item)" class="text-xs text-blue-600">
              S/N: {{ getSerialNumber(item) }}
            </div>
          </div>
          <div class="flex items-center gap-1 ml-2">
            <!-- Переместить -->
            <button
              v-if="totalPlaces > 1"
              v-can-write
              @click="$emit('move-item', item._localId)"
              class="text-blue-500 hover:text-blue-700 p-1"
              title="Переместить в другое место"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
            </button>
            <!-- Удалить -->
            <button
              v-can-write
              @click="$emit('remove-item', item._localId)"
              class="text-red-400 hover:text-red-600 p-1"
              title="Убрать из места"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PackingPlaceCard',
  props: {
    place: { type: Object, required: true },
    isSelected: { type: Boolean, default: false },
    totalPlaces: { type: Number, default: 1 },
  },
  emits: ['select', 'delete', 'remove-item', 'move-item', 'focus-scanner'],
  methods: {
    getProductName(item) {
      const p = item.product;
      if (!p) return '';
      return p.comment || p.name || '';
    },
    getSerialNumber(item) {
      return item.batch_product?.serial_number || item.serial_number || null;
    },
    updateField(field, value) {
      this.$emit('update-place', {
        _localId: this.place._localId,
        [field]: value,
      });
    },
  },
};
</script>
